module.exports = __webpack_public_path__ + "media/warranty-claim/warranty_proof_of_purchase_thumbnail-5d6206a8.png";